export enum SessionType {
    DAY = "DAY",
    HALF_DAY = "HALF-DAY",
    OVERNIGHT = "OVERNIGHT",
    EXTENDED = "EXTENDED",
    CLINIC = "CLINIC",
}

export enum RegistrationStatus {
    REGISTER = "REGISTER",
    FULL = "FULL",
    COACH_VIEW = "VIEW", // For camp owners/coaches - shows "VIEW" text
    CAMPER_VIEW = "VIEW", // For registered campers - shows "VIEW" text with different color
}

export interface SessionInterface {
    startAge: string;
    endAge: string;
    title: string;
    capacity: string;
    sessionType: SessionType;
    // Readable date strings kept for UI
    startDate: any;
    endDate: any;
    // Timestamps for robust comparisons and queries
    createdAt?: any; // Firestore Timestamp
    startAt?: any;   // Firestore Timestamp
    endAt?: any;     // Firestore Timestamp
    startTime: string;
    endTime: string;
    daysOfWeek?: string[]; // Optional restriction of days (e.g., ['Mon','Wed'])
    daysMask?: number; // 7-bit mask for days (Sun bit0 .. Sat bit6)
    price: string;
    isHidden: boolean;
    registeredUsers?: Record<string, string>; // userId -> userName mapping
    instructor?: any; // Camp instructor object (deprecated in favor of coach)
    coach?: any; // Assigned coach object
    // Session media
    sessionImageUrls?: string[]; // Uploaded session-specific images
    imageUrls?: string[]; // Legacy fallback
    // Waiver
    waiverRequired?: boolean;
    waiverTitle?: string;  // Original filename of the uploaded document
    waiverUrl?: string;    // Firebase Storage download URL
}